import React from 'react';
import { useNavigate } from 'react-router-dom';

const BottomNav = ({ activeTab }) => {
  const navigate = useNavigate();

  const tabs = [
    {
      id: 'home',
      label: 'Home',
      path: '/',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
    },
    {
      id: 'leagues',
      label: 'Leagues',
      path: '/leagues',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" /><path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" /><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" /><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" /></svg>
    },
    {
      id: 'my-teams',
      label: 'My Teams',
      path: '/my-teams',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
    },
    {
      id: 'profile',
      label: 'Profile',
      path: '/profile',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-theme-card border-t border-theme-border flex justify-around py-2 z-50" style={{ paddingBottom: 'max(8px, env(safe-area-inset-bottom, 8px))' }}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`flex flex-col items-center justify-center w-full transition-all duration-300 ${isActive ? 'text-green-500' : 'text-theme-text-sec hover:text-theme-text-sec'}`}
          >
            <div className={`p-1.5 rounded-full transition-transform duration-300 ${isActive ? 'bg-green-500/20 transform -translate-y-1' : ''}`}>
              {tab.icon}
            </div>
            <span className={`text-[10px] mt-0.5 tracking-wide ${isActive ? 'font-bold' : 'font-medium'}`}>
              {tab.label}
            </span>
          </button>
        )
      })}
    </div>
  );
};
export default BottomNav;
